import { combineReducers } from 'redux';

import resolvedList from './complaintResolvedList';
import reqSendReport from './reqSendReport';
import unresolvedList from './complaintUnResolvedList';
import resolveComplaint from './resolveComplaint';
import counters from './complaintCounters';
import details from './complaintDetails';

export default combineReducers({
  reqSendReport,
  resolvedList,
  unresolvedList,
  resolveComplaint,
  counters,
  details,
});



// WEBPACK FOOTER //
// ./src/redux/complaints/index.js